import { from } from "rxjs";
import { selectBuildingUpgradeLevelRequirements } from "../../../../selectors/selectExistingBuildingInfo";
import { IdCharacterHelpType } from "../../../character-help-dialog/IdCharacterHelpType";
import { actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionOngoingPurchaseCharacterHelpSelect } from "../../../ongoing-purchase/actionOngoingPurchase";
export var pathBuildingUpgradeCharacterHelpMissingLevel = function (action$, state$) {
    var state = state$.value;
    var playerInfo = state.playerInfo;
    var building = action$.building, premium = action$.premium;
    var levelRequirement = selectBuildingUpgradeLevelRequirements(state, building, premium);
    var actions = [];
    if (levelRequirement.requiredPlayerLevel &&
        playerInfo.level < levelRequirement.requiredPlayerLevel) {
        var missing = levelRequirement.requiredPlayerLevel - playerInfo.level;
        var characterHelpInfo = {
            missing: missing.toString(),
            type: IdCharacterHelpType.MissingPlayerLevel,
        };
        actions.push(actionOngoingPurchaseCharacterHelpSelect(characterHelpInfo));
    }
    else if (levelRequirement.requiredAdventurerLevel &&
        (playerInfo.adventurerLevel || 0) < levelRequirement.requiredAdventurerLevel) {
        var missing = levelRequirement.requiredAdventurerLevel - (playerInfo.adventurerLevel || 0);
        var characterHelpInfo = {
            missing: missing.toString(),
            type: IdCharacterHelpType.MissingPlayerLevel,
        };
        actions.push(actionOngoingPurchaseCharacterHelpSelect(characterHelpInfo));
    }
    actions.push(actionModalOpen(IdModal.CharacterHelp));
    return from(actions);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/path/pathBuildingUpgradeCharacterHelpMissingLevel.ts
// module id = 2077
// module chunks = 3